<script>
  import {parse} from 'qs'
  import {link, querystring} from 'svelte-spa-router'
  import WinnerItem from './WinnerItem.svelte'
  import Loader from '../Loader.svelte'
  import { years, perPage, mobileFiltersOpen } from './stores.js'
  import LoadMoreBar from './LoadMoreBar.svelte'

  let winners = []
  let _years = []
  let disciplines = []
  let isLoading = true
  let isLoadingMore = false
  let _mobileFiltersOpen = false
  let totalPages = 0
  let page = 1

  years.subscribe((value) => { _years = value })
  mobileFiltersOpen.subscribe((value) => { _mobileFiltersOpen = value })

  $: params = parse($querystring)
  
  $: fetch(`/wp-json/ya/v1/winners?${$querystring}&per_page=${perPage}`)
    .then((r) => {
      totalPages = parseInt(r.headers.get('X-WP-TotalPages'), 10)
      return r.json()
    }).then((data) => {
      isLoading = false

      if (data) {
        winners = data
      } else {
        winners = []
      }
    })

  $: fetch(`/wp-json/wp/v2/winner_discipline?parent=0`)
    .then((r) => r.json())
    .then((data) => {
      if (data) {
        disciplines = data
      }
    })

  window.addEventListener("hashchange", (event) => {
    winners = []
    isLoading = true
  });

  function getQueryString (_params, param, value, mode = 'replace') {
    let qs = '/?'
    if (mode === 'replace') {
      if (param === 'year') {
        if (_params.discipline) { qs += `discipline=${_params.discipline}&` }
        qs += `year=${value}`
      } else if (param === 'discipline') {
        if (_params.year) { qs += `year=${_params.year}&` }
        qs += `discipline=${value}`
      }
    } else if (mode === 'remove') {
      if (param === 'year') {
        if (_params.discipline) { qs += `discipline=${_params.discipline}` }
      } else if (param === 'discipline') {
        if (_params.year) { qs += `year=${_params.year}` }
      }
    }

    return qs
  }

  function appendResults() {
    isLoadingMore = true
    page++
    fetch(`/wp-json/ya/v1/winners?${$querystring}&per_page=${perPage}&page=${page}`)
      .then((r) => r.json())
      .then((data) => {
        isLoadingMore = false

        if (data) {
          winners = [...winners, ...data]
        }
      })
  }
</script>

<div>
  <div class="ya-grid gap-y-5 md:mt-10">
    <!-- Filters col -->
    <div class="col-span-6 md:col-span-3 xl:col-span-2">
      <div class={`${_mobileFiltersOpen ? '' : 'hidden'} md:block md:sticky top-24 lg:top-36 space-y-6 mt-5 md:mt-0`}>
        <!-- Years -->
        <div>
          <div class="md:border-t-2 border-black flex justify-between">
            <div class="font-display font-bold text-xl">Year</div>
            <a 
              class={`font-bold text-sm text-gray-500 ${!params.year ? 'hidden' : ''}`}
              href={getQueryString(params, 'year', null, 'remove')} use:link
            >Clear &times;</a>
          </div>
          <ul class="mt-2">
            {#each _years as item}
              <li class="font-display font-bold">
                <a 
                  href={getQueryString(params, 'year', item.slug)} use:link 
                  class={params.year === item.slug ? 'text-purple' : ''}
                >{item.name}</a>
              </li>
            {/each}
          </ul>
        </div>
        <!-- Disciplines -->
        <div>
          <div class="md:border-t-2 border-black flex justify-between">
            <div class="font-display font-bold text-xl">Discipline</div>
            <a 
              class={`font-bold text-sm text-gray-500 ${!params.discipline ? 'hidden' : ''}`} 
              href={getQueryString(params, 'discipline', null, 'remove')} use:link
            >Clear &times;</a>
          </div>
          <ul class="mt-2">
            {#each disciplines as item}
              <li class="font-display font-bold">
                <a 
                  href={getQueryString(params, 'discipline', item.slug)} use:link 
                  class={params.discipline === item.slug ? 'text-purple' : ''}
                >{item.name}</a>
              </li>
            {/each}
          </ul>
        </div>
      </div>
    </div>
    <!-- Results col -->
    <div class="col-span-6 md:col-span-9 xl:col-start-4">
      <div class="grid ya-grid-gap grid-cols-2 lg:grid-cols-4 gap-y-8">
        {#if isLoading}
          <Loader />
        {:else}
          {#if winners.length}
            {#each winners as item, i}
              <WinnerItem 
                name={item.title}
                school={item.school}
                city={item.city} 
                state={item.state}
                disciplines={item.disciplines}
                parentDisciplines={item.parent_disciplines} 
                childDisciplines={item.child_disciplines} 
                years={item.years}
                awardLevels={item.award_levels}
                subdisciplineModifier={item.subdiscipline_modifier}
              />
            {/each}
          {:else}
            <div class="col-span-3">
              <p>Sorry, no results found. Please try changing your search parameters.</p>
            </div>
          {/if}
        {/if}
      </div>
      <!-- Load more -->
      {#if !isLoading && winners.length}
        <LoadMoreBar page={page} totalPages={totalPages} isLoadingMore={isLoadingMore} on:loadMoreClick={appendResults} />
      {/if}
    </div>
  </div>
</div>